"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initEvent = _interopRequireDefault(require("./initEvent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var state = {
  data: (0, _initEvent["default"])(),
  addType: function addType(type) {
    this.data.eventTypes.add(type);
    if (!this.data.type) this.data.type = type;
  },
  getEvent: function getEvent() {
    return {
      event: this.data.type,
      xdm: {
        web: {
          webPageDetails: this.data.webPageDetails,
          webInteraction: this.data.webInteraction
        },
        productListItems: this.data.productListItems,
        commerce: this.data.commerce,
        search: this.data.search,
        media: this.data.media
      }
    };
  },
  reset: function reset() {
    this.data = (0, _initEvent["default"])();
  }
};
var _default = exports["default"] = state;